import { Injectable, inject } from '@angular/core';
import { ApiServerService } from '../api';

export type LogSeverity = 'INFO' | 'DEBUG' | 'WARNING' | 'ERROR';

interface LogPayload {
  message: string;
  severity: LogSeverity;
  context: any;
  client: string;
}

@Injectable({ providedIn: 'root' })
export class LoggerService {
  private readonly api = inject(ApiServerService);
  private readonly client = 'app';

  info(message: string, context: any = null) {
    return this.send('INFO', message, context);
  }

  debug(message: string, context: any = null) {
    return this.send('DEBUG', message, context);
  }

  warning(message: string, context: any = null) {
    return this.send('WARNING', message, context);
  }

  error(message: string, context: any = null) {
    return this.send('ERROR', message, context);
  }

  private send(severity: LogSeverity, message: string, context: any = null): Promise<unknown> {
    const data: LogPayload = { message, severity, context, client: this.client };
    return this.api.call('logs', data);
  }
}
